import type { Hall } from '../api/types';

/**
 * The venue's free-text amenities, minus the ones its structured fields
 * already say. A manager often types "AC", "Parking" or "Catering" into the
 * amenity list as well as ticking the matching box, and a card that lists
 * "Full AC" and then "AC" reads as careless.
 */
const COVERED: Array<[keyof Hall, RegExp]> = [
  ['has_ac', /^(a\.?c\.?|air[- ]?con(ditioned|ditioning)?|full a\.?c\.?|centrally air[- ]?conditioned)$/i],
  ['has_parking', /^(car |bike |two[- ]wheeler )?parking$/i],
  ['has_lift', /^(lift|elevator)s?$/i],
];

export function extraAmenities(
  hall: Pick<Hall, 'amenities' | 'has_ac' | 'has_parking' | 'has_lift' | 'catering' | 'rooms'>,
): string[] {
  const seen = new Set<string>();
  return hall.amenities.filter((raw) => {
    const a = String(raw).trim();
    const key = a.toLowerCase();
    if (!a || seen.has(key)) return false;
    seen.add(key);
    if (COVERED.some(([field, re]) => hall[field as 'has_ac'] && re.test(a))) return false;
    if (hall.catering && hall.catering !== 'none' && /^catering$/i.test(a)) return false;
    if (hall.rooms > 0 && /^(a\.?c\.? )?rooms?$/i.test(a)) return false;
    return true;
  });
}
